module.exports = "\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component.html
// module id = ./src/app/enquiry-reports/enquiry-report-menu/enquiry-report-menu/enquiry-report-menu.component.html
// module chunks = main